export default __webpack_public_path__ + "static/media/ck.4d0130d8.jpg";